import PropTypes from 'prop-types';
import React from 'react';
import { RawHTML } from '@wordpress/element';
import DOMPurify from 'dompurify';

import usStateCodes from 'us-state-codes';
import getDescription from './procedures';

/**
 * Displays Opioid Prescribers filters
 */
export default class OpioidFilters extends React.PureComponent {

  /**
   * @returns {object} - JSX for the component.
   */
  render() {
    const {
      activeProcedure,
      activeSearch,
      activeState,
      onFilter,
      procedures,
      states,
    } = this.props;

    const activeStateFullName =
      usStateCodes.getStateNameByStateCode(activeState);
    // Sort by full state names for dropdown
    const stateNamesSorted = states.map((state) =>
      usStateCodes.getStateNameByStateCode(state)).sort();

    return (
      <div className="opioidPrescribers-filters">
        {/* Dropdowns */}
        <div className="filter-row filter--dropdowns">
          Opioid prescribing habits of doctors in
          <div className="filter filter--state">
            <select
              id="state-select"
              value={'all' !== activeStateFullName ?
              activeStateFullName : 'all'}
              onChange={(event) =>
                onFilter('activeState', 'all' === event.target.value ?
                'all' :
                usStateCodes.getStateCodeByStateName(event.target.value))
              }
            >
              <option value="all">the United States</option>
              {stateNamesSorted.map((optState) => (
                <option
                  key={optState}
                >
                  {optState}
                </option>
              ))}
            </select>
          </div>
          following
          <div className="filter filter--procedure">
            <select
              id="procedure-select"
              value={activeProcedure}
              onChange={(event) =>
                onFilter('activeProcedure', event.target.value)
              }
            >
              {procedures.map((procedure) => (
                <option
                  key={procedure}
                >
                  {procedure}
                </option>
              ))}
            </select>
          </div>
        </div>
        {/* Active proceedure description */}
        <div className="filter-row procedure-description">
          <RawHTML>
            {DOMPurify.sanitize(getDescription(activeProcedure))}
          </RawHTML>
        </div>
        {/* Search field */}
        <div className="filter-row">
          <div className="filter filter--search">
            <input
              id="search-select"
              type="text"
              placeholder="Filter by doctor name or practicing hospital..."
              value={activeSearch || ''}
              onChange={(event) =>
                onFilter('activeSearch', event.target.value)}
            />
          </div>
        </div>
      </div>
    );
  }
}

OpioidFilters.propTypes = {
  activeProcedure: PropTypes.string.isRequired,
  activeState: PropTypes.string,
  activeSearch: PropTypes.string,
  onFilter: PropTypes.func.isRequired,
  procedures: PropTypes.instanceOf(Array).isRequired,
  states: PropTypes.instanceOf(Array).isRequired,
};

OpioidFilters.defaultProps = {
  activeSearch: null,
  activeState: null,
};
